import { render, staticRenderFns } from "./fieldTelefone.vue?vue&type=template&id=592226ff&scoped=true"
import script from "./fieldTelefone.vue?vue&type=script&lang=js"
export * from "./fieldTelefone.vue?vue&type=script&lang=js"
import style0 from "./fieldTelefone.vue?vue&type=style&index=0&id=592226ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592226ff",
  null
  
)

export default component.exports